    <dp-table [table]="table" [customStyles]="{'cssClass':'table table-hover'}" [showLoading]="showLoading"
        [heightScroll]="'39vh'">
    </dp-table>
    <dp-pagination [hidden]="getElements() === 0" style="display: flex; flex-direction: column"
        (newPageSize)="onChangePageSize($event)" (newPage)="onChangePage($event)" [pageSizes]="[25, 50, 100]"
        [page]="getCurrentPage()" [elements]="getElements()">
    </dp-pagination>